<template>
  <div id="app">
    <router-view class="main-container"></router-view>
    <nav v-if="$route.meta.showNav" class="bottom-nav w3-bar w3-green" >
      <router-link to="/dashb" class="w3-bar-item w3-button">DashB</router-link>
      <router-link to="/cslist" class="w3-bar-item w3-button">CS</router-link>      
      <router-link to="/coinr" class="w3-bar-item w3-button">CoinR</router-link>
      <router-link to="/gamer" class="w3-bar-item w3-button">GameR</router-link>
      <router-link to="/withdrawTX" class="w3-bar-item w3-button">Withdraw</router-link>
    </nav>
  </div>
</template>

<style>
#app {
  position: relative;
  min-height: 100vh; 
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
.main-content {
  padding-bottom: 60px;
}

.router-link-active {
  background-color: #003366 !important;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000; 
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1); 
}
</style>